module.exports={
  "type": "FeatureCollection",
  "features": [{
    "type": "Feature",
    "properties": {
      "incident_date": "Mar. 31, 2013",
      "month": "March",
      "year": 2013,
      "city": "Auburn",
      "address": "2802 Auburn Way N.",
      "killed": 3,
      "injured": 2,
      "info": "Three people were killed in a shooting after a dispute in the parking lot of an Auburn sports bar.",
      "link1": "http://blogs.seattletimes.com/today/2013/03/three-dead-in-auburn-tavern-shootout/",
      "link2": null,
      "Perpetrator Killed": "N",
      "Drugs": "N",
      "Officer Involved": "N",
      "School": "N",
      "Domestic Violence": "N",
      "Unlawful Purchase/Sale": "N",
      "Armed Robbery": "N",
      "Home Invasion": "N",
      "Gang": "N",
      "Drive By": "N",
      "Bar/Club": "Y",
      "Felon/Prohibited Person": "N",
      "Concealed Carry Lic.": "N"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.220788, 47.332168]
    }
  }, {
    "type": "Feature",
    "properties": {
      "incident_date": "Apr. 21, 2013",
      "month": "April",
      "year": 2013,
      "city": "Federal Way",
      "address": "33300 block of 18th Lane S.",
      "killed": 5,
      "injured": 0,
      "info": "A 27-year-old Federal Way man shot and killed his girlfriend in their apartment, then killed three others before he was fatally shot by police.",
      "link1": "http://www.seattletimes.com/seattle-news/witnesses-among-5-dead-in-federal-way/",
      "link2": null,
      "Perpetrator Killed": "Y",
      "Drugs": "N",
      "Officer Involved": "N",
      "School": "N",
      "Domestic Violence": "Y",
      "Unlawful Purchase/Sale": "N",
      "Armed Robbery": "N",
      "Home Invasion": "Y",
      "Gang": "N",
      "Drive By": "N",
      "Bar/Club": "N",
      "Felon/Prohibited Person": "N",
      "Concealed Carry Lic.": "Y"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.310402, 47.303052]
    }
  }, {
    "type": "Feature",
    "properties": {
      "incident_date": "Jul. 29, 2013",
      "month": "July",
      "year": 2013,
      "city": "Granger",
      "address": "300 block of S. Outlook Rd.",
      "killed": 0,
      "injured": 4,
      "info": "Four teenagers were injured in a gang-related shooting as they left a party in Granger, Yakima County.",
      "link1": "http://www.seattletimes.com/seattle-news/4-teens-wounded-in-granger-shooting/",
      "link2": null,
      "Perpetrator Killed": "N",
      "Drugs": "N",
      "Officer Involved": "N",
      "School": "N",
      "Domestic Violence": "N",
      "Unlawful Purchase/Sale": "N",
      "Armed Robbery": "N",
      "Home Invasion": "N",
      "Gang": "N",
      "Drive By": "N",
      "Bar/Club": "N",
      "Felon/Prohibited Person": "N",
      "Concealed Carry Lic.": "N"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-120.093699, 46.323622]
    }
  }, {
    "type": "Feature",
    "properties": {
      "incident_date": "Sep. 15, 2013",
      "month": "September",
      "year": 2013,
      "city": "Yakima",
      "address": "2209 W. Nob Hill Blvd.",
      "killed": 0,
      "injured": 6,
      "info": "Four men and two women were shot in a parking lot outside Aladdin’s Hookah Lounge, a private smoking club in Yakima.",
      "link1": "http://blogs.seattletimes.com/today/2013/09/police-victims-of-yakima-hookah-lounge-shooting-uncooperative/",
      "link2": null,
      "Perpetrator Killed": "N",
      "Drugs": "N",
      "Officer Involved": "N",
      "School": "N",
      "Domestic Violence": "N",
      "Unlawful Purchase/Sale": "N",
      "Armed Robbery": "N",
      "Home Invasion": "N",
      "Gang": "Y",
      "Drive By": "Y",
      "Bar/Club": "Y",
      "Felon/Prohibited Person": "N",
      "Concealed Carry Lic.": "N"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-120.539077, 46.585842]
    }
  }, {
    "type": "Feature",
    "properties": {
      "incident_date": "Jan. 27, 2014",
      "month": "January",
      "year": 2014,
      "city": "Seattle",
      "address": "2nd Ave. S. & S. Main St.",
      "killed": 1,
      "injured": 4,
      "info": "Five people were wounded – one fatally – after a fight broke out outside a nightclub in the Pioneer Square neighborhood of Seattle.",
      "link1": "http://www.seattletimes.com/seattle-news/5-wounded-mdash-1-critically-mdash-in-shootout-at-pioneer-square/",
      "link2": null,
      "Perpetrator Killed": "N",
      "Drugs": "N",
      "Officer Involved": "N",
      "School": "N",
      "Domestic Violence": "N",
      "Unlawful Purchase/Sale": "N",
      "Armed Robbery": "N",
      "Home Invasion": "N",
      "Gang": "Y",
      "Drive By": "N",
      "Bar/Club": "N",
      "Felon/Prohibited Person": "Y",
      "Concealed Carry Lic.": "N"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.331554, 47.60003]
    }
  }, {
    "type": "Feature",
    "properties": {
      "incident_date": "Jul. 13, 2014",
      "month": "July",
      "year": 2014,
      "city": "Skyway",
      "address": "12600 Renton Ave. S.",
      "killed": 0,
      "injured": 5,
      "info": "Six people were injured – one seriously – in an early-morning shooting in Skyway parking lot.",
      "link1": "http://blogs.seattletimes.com/today/2014/07/five-people-injured-in-skyway-shooting-early-this-morning/",
      "link2": null,
      "Perpetrator Killed": "N",
      "Drugs": "N",
      "Officer Involved": "N",
      "School": "N",
      "Domestic Violence": "N",
      "Unlawful Purchase/Sale": "N",
      "Armed Robbery": "N",
      "Home Invasion": "N",
      "Gang": "N",
      "Drive By": "N",
      "Bar/Club": "N",
      "Felon/Prohibited Person": "N",
      "Concealed Carry Lic.": "N"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.239292, 47.491732]
    }
  }, {
    "type": "Feature",
    "properties": {
      "incident_date": "Oct. 24, 2014",
      "month": "October",
      "year": 2014,
      "city": "Marysville",
      "address": "5611 108th St. N.E.",
      "killed": 5,
      "injured": 1,
      "info": "Freshman Jaylen Fryberg shot five students at Marysville Pilchuck High School, killing four, before fatally shooting himself. Fryberg's father was convicted in 2015 for illegally possessing the gun used in the shooting.",
      "link1": "http://www.seattletimes.com/seattle-news/education/marysville-aching-healing-a-year-after-high-school-shooting/",
      "link2": null,
      "Perpetrator Killed": "Y",
      "Drugs": "N",
      "Officer Involved": "N",
      "School": "Y",
      "Domestic Violence": "N",
      "Unlawful Purchase/Sale": "N",
      "Armed Robbery": "N",
      "Home Invasion": "N",
      "Gang": "N",
      "Drive By": "N",
      "Bar/Club": "N",
      "Felon/Prohibited Person": "Y",
      "Concealed Carry Lic.": "N"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.154325, 48.095939]
    }
  }, {
    "type": "Feature",
    "properties": {
      "incident_date": "Nov. 22, 2015",
      "month": "November",
      "year": 2015,
      "city": "Seattle",
      "address": "Broadway & E. Pike St.",
      "killed": 0,
      "injured": 4,
      "info": "Five people suffered minor injuries from a drive-by shooting in Seattle’s Capitol Hill neighborhood. Four of the victims suffered gunshot wounds while the fifth was injured by flying glass from a plate-glass window shattered by bullets.",
      "link1": "http://www.seattletimes.com/seattle-news/five-hurt-in-capitol-hill-shooting-suspects-sought/",
      "link2": null,
      "Perpetrator Killed": "N",
      "Drugs": "N",
      "Officer Involved": "N",
      "School": "N",
      "Domestic Violence": "N",
      "Unlawful Purchase/Sale": "N",
      "Armed Robbery": "N",
      "Home Invasion": "N",
      "Gang": "Y",
      "Drive By": "Y",
      "Bar/Club": "N",
      "Felon/Prohibited Person": "Y",
      "Concealed Carry Lic.": "N"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.320804, 47.614088]
    }
  }, {
    "type": "Feature",
    "properties": {
      "incident_date": "Jan. 26, 2016",
      "month": "January",
      "year": 2016,
      "city": "Seattle",
      "address": "Airport Way S. and S. Atlantic St.",
      "killed": 2,
      "injured": 3,
      "info": "In a dispute, three women and two men were shot – two fatally – at the Seattle homeless encampment known as The Jungle.",
      "link1": "http://www.seattletimes.com/seattle-news/crime/active-shooter-in-seattles-sodo-district-near-i-5/",
      "link2": null,
      "Perpetrator Killed": "N",
      "Drugs": "Y",
      "Officer Involved": "N",
      "School": "N",
      "Domestic Violence": "N",
      "Unlawful Purchase/Sale": "Y",
      "Armed Robbery": "Y",
      "Home Invasion": "N",
      "Gang": "N",
      "Drive By": "N",
      "Bar/Club": "N",
      "Felon/Prohibited Person": "N",
      "Concealed Carry Lic.": "N"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.322627, 47.590301]
    }
  }, {
    "type": "Feature",
    "properties": {
      "incident_date": "Feb. 26, 2016",
      "month": "February",
      "year": 2016,
      "city": "Belfair",
      "address": "300 block of Horseshoe Rd.",
      "killed": 5,
      "injured": 0,
      "info": "In a rural area near Belfair in Mason County, David Wayne Campbell, 51, shot his wife, her two children, a neighbor and then himself. Campbell had an extensive criminal history that would have made it illegal for him to possess firearms.",
      "link1": "http://www.seattletimes.com/seattle-news/crime/fourth-victim-of-belfair-shooting-identified-as-neighbor/",
      "link2": null,
      "Perpetrator Killed": "Y",
      "Drugs": "N",
      "Officer Involved": "Y",
      "School": "N",
      "Domestic Violence": "Y",
      "Unlawful Purchase/Sale": "N",
      "Armed Robbery": "N",
      "Home Invasion": "N",
      "Gang": "N",
      "Drive By": "N",
      "Bar/Club": "N",
      "Felon/Prohibited Person": "Y",
      "Concealed Carry Lic.": "N"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [-122.931261, 47.503307]
    }
  }]
}
